/**
 * Ancestor tools.
 */
H_Tools.ancestors = (() => {
    // console.log('Ancestor tools initialized');

    /**
     * Finds all ancestor elements of the specified element.
     *
     * @param {*} element   The element whose ancestors to look for
     * @param {*} container (Optional) A container element to limit the search inside of
     * @param {*} css_class (Optional) A css class to filter ancestors
     * @returns             An array of ancestor elements that match the criteria, or [] if none do
     */
    function getAllAncestors(element, container, css_class = false) {
        let result = [];
        let parent = element.parentElement;
        while (
            parent &&
            (container !== false || !parent.isEqualNode(container))
        ) {
            if (css_class === false || parent.classList.contains(css_class)) {
                result.push(parent);
            }
            parent = parent.parentElement;
        }
        return result;
    }

    // return an object to expose inner functions
    return {
        getAllAncestors: getAllAncestors,
    };
})();
